import API from "../axios/API";
import * as types from "../../reduxStore/types/subscription";

export const fetchSubscriptionConfigurations = (restaurantId) => {
  return async (dispatch, getState) => {
    let subscriptionResponse;

    try {
      subscriptionResponse = await API.get(
        `restaurants/${restaurantId}/subscription-configurations`,
      );
    } catch (error) {
      subscriptionResponse = error;
    }

    return subscriptionResponse;
  };
};
